import { render, staticRenderFns } from "./ValeFinance.vue?vue&type=template&id=68aea36d&scoped=true&"
import script from "./ValeFinance.vue?vue&type=script&lang=js&"
export * from "./ValeFinance.vue?vue&type=script&lang=js&"
import style0 from "./ValeFinance.vue?vue&type=style&index=0&id=68aea36d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68aea36d",
  null
  
)

export default component.exports